module.exports = __webpack_public_path__ + "static/media/10ton-variant-3.b5a3c551.jpg";